<template>
  <div class="msgDetails">
    <div class="zMsgSearch">
      <span>{{$t('common.dateRange')}}</span>
      <el-date-picker
        size="small"
        v-model="DataValue"
        type="datetimerange"
        :clearable="false"
        value-format="yyyy-MM-dd HH:mm:ss"
        :range-separator="$t('common.to')"
        :start-placeholder="$t('common.starDate')"
        :end-placeholder="$t('common.endDate')"
      >
      </el-date-picker>
      <el-button
        style="margin-left: 18px"
        @click="onSearch"
        size="small"
        type="primary"
        class="btn-chaxun"
        >{{$t('common.btn.search')}}</el-button
      >
      <el-button @click="onClear" size="small" class="btn-del">{{$t('common.btn.cancel')}}</el-button>
    </div>
    <div class="zMsgBtn">
      <el-button type="text" @click="down">{{$t('common.btn.download')}}</el-button>
    </div>
    <div class="zMsgTable">
      <i-table
        :list="list"
        :height="height"
        ref="carTable"
        @handleSelectionChange="handleSelectionChange"
        :options="option"
        :columns="columns"
        :operates="operates"
      ></i-table>
      <IPagination ref="page" @PageFun="changeSize"></IPagination>
    </div>
  </div>
</template>

<script>
import iTable from "../../../../../src/components/Table.vue";
import IPagination from "../../../../../src/components/pagination.vue";
import { domainName } from "../../../../utility/index";
import moment from 'moment';
export default {
  props: ["bindDrive"],

  components: {
    iTable,
    IPagination,
  },
  data() {
    return {
      DataValue: [],
      height: "350",
      list: [], 
      option: {
        stripe: true, 
        border: true,
        loading: false, 
        highlightCurrentRow: false, 
        mutiSelect: false, 
        serialNumber: true, 
      },
      columns: [
        {
          prop: "carId",
          label: this.$t('DriverManagement.carId'),
          align: "center",
          width: "160",
        },
        {
          prop: "workTime",
          label: this.$t('DriverManagement.workHour'),
          align: "center",
          width: "160",
        },
        {
          prop: "startTime",
          label: this.$t('DriverManagement.startTime'),
          align: "center",
        },
        {
          prop: "endTime",
          label: this.$t('DriverManagement.endTime'),
          align: "center",
        },
      ],
      operates: {
        width: 100,
        fixed: "right",
        list: [],
      },
      currentPage: 1, 
      pageSize: 10, 
      total: 1, 
    };
  },
  created() {
    this.getDate()
  },
  methods: {
    getDate() {
      const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
      const startTime = moment().startOf("month").format("YYYY-MM-DD HH:mm:ss");
      this.DataValue = [startTime, endTime];
    },
    getDriverSwipingCard() {
      let startTime = "";
      let endTime = "";
      if (this.DataValue) {
        if (this.DataValue.length > 0) {
          startTime = this.DataValue[0];
          endTime = this.DataValue[1];
        }
      }
      let param = {
        driverNum: this.bindDrive,
        startTime: startTime,
        endTime: endTime,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      this.$store
        .dispatch("DriverStatus/GET_DRIVERSTOPEVENT", param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.list = res.data.data.list;
              this.$refs.page.CommandTotal = res.data.data.total;
            }
          }
        })
        .catch((err) => {});
    },
    onSearch() {
      this.$refs.page.CommandCurrentPage = 1
      this.currentPage = 1
      this.getDriverSwipingCard();
    },
    onClear() {
      this.getDate()
      this.getDriverSwipingCard();
    },
    handleSelectionChange(val) {
      this.selected = val;
    },
    changeSize(item) {
      this.pageSize = item.pageSize;
      this.currentPage = item.pageNum;
      this.getDriverSwipingCard();
    },
    down() {
      if (domainName) {
        if (domainName.split(":")[0] !== "localhost") {
          let startTime = "";
          let endTime = "";
          if (this.DataValue) {
            if (this.DataValue.length > 0) {
              startTime = this.DataValue[0];
              endTime = this.DataValue[1];
            }
          }
          let url = `https://${domainName}/v1/getExportExcel/exportSelectStopEvent?driverNum=${this.bindDrive}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        } else {
          let host = "localhost:8080";
          let url = `https://${host}/v1/getExportExcel/exportSelectStopEvent?driverNum=${this.bindDrive}&startTime=${startTime}&endTime=${endTime}`;
          location.href = url;
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>